module.exports = __webpack_public_path__ + "static/media/eduardo@2x.1cfa164a.jpg";